<template>
  <WhiteIQOS required :title="$t('tax_selector.title')" bodyClass="gap-row-xs">
      <BaseSelect :value="value" :disabled="!editing" @input="v => $emit('input', v)" fullWidth v-if="taxes">
        <option :value="null">
            {{ $t('tax_selector.no_tax') }}
        </option>
        <option :value="'parent'" v-if="inProduct">
            {{ $t('tax_selector.use_parent') }}
        </option>
        <option v-for="tax in taxes" :key="tax._id" :value="tax._id">
            {{ tax.name }} ({{ tax.percent}}%)
        </option>
      </BaseSelect>
      <p class="iqos-comment">
          {{ $t(inProduct ? 'tax_selector.comment' : 'tax_selector.menu_comment') }}
      </p>

      <template #actions>
          <WhiteIQOSActions :editing="editing" @edit="editing = true" @accept="editing = false"/>
      </template>
  </WhiteIQOS>
</template>

<script>
import TaxesAPI from '@/api/taxes'

export default {
    props: {
        value: String,
        inProduct: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            taxes: null,
            editing: false
        }
    },
    methods: {

    },
    mounted() {
        TaxesAPI.getTaxes(this.$store.state.cafe._id).then(data => {
            this.taxes = data.taxes || [];
        }).catch(err => {
            this.taxes = [];
        })
    }
}
</script>

<style>

</style>